import { ajax } from '@/api/ajax';

export const getUser = () => {
  return ajax({
    method: 'GET',
    url: '/sso/getUserInfo'
  });
};
